import {useEffect, useState} from "react";
import { MdOutlineArrowOutward } from "react-icons/md";
import { MdKeyboardArrowDown } from "react-icons/md";
import { IoCloseCircleOutline } from "react-icons/io5";
import { MdErrorOutline } from "react-icons/md";
import apiRequests from "../../Component/axios/config/config";
// const transactions = [
//   {
//     id: 1,
//     amount: "32.45",
//     type: "payout",
//     txId: "#458329412325",
//     status: "Successful",
//     date: "05:30 - 12 may 2025",
//     sign: "-",
//     hasLink: false,
//   },
//   {
//     id: 2,
//     amount: "32.45",
//     type: "Order",
//     txId: "#458329",
//     status: "Failed",
//     date: "05:30 - 12 may 2025",
//     sign: "+",
//     hasLink: true,
//   },
//   {
//     id: 3,
//     amount: "32.45",
//     type: "Order",
//     txId: "#458329",
//     status: "Successful",
//     date: "05:30 - 12 may 2025",
//     sign: "+",
//     hasLink: true,
//   },
//   {
//     id: 4,
//     amount: "32.45",
//     type: "Order",
//     txId: "#458329",
//     status: "Successful",
//     date: "05:30 - 12 may 2025",
//     sign: "+",
//     hasLink: true,
//   },
//   {
//     id: 5,
//     amount: "32.45",
//     type: "payout",
//     txId: "#458329412325",
//     status: "Failed",
//     date: "05:30 - 12 may 2025",
//     sign: "-",
//     hasLink: false,
//   },
//   {
//     id: 6,
//     amount: "32.45",
//     type: "Order",
//     txId: "#458329",
//     status: "Successful",
//     date: "05:30 - 12 may 2025",
//     sign: "+",
//     hasLink: true,
//   },
// ];

const FILTERS = [ "Orders", "payout"];
const statusList = [
  { id: 1, name: "Successful" },
  { id: 2, name: "Failed" },
];
const accountTypes = [
  "Checking (Personal)",
  "Savings (Personal)",
  "Business Checking",
];

export default function EarningsPayouts() {
  const [activeFilter, setActiveFilter] = useState("Orders");
  const [status, setStatus] = useState({ id: "", name: "Status" });
  const [open, setOpen] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [openAccountType, setOpenAccountType] = useState(false);
  const [form, setForm] = useState({
    accountHolder: "",
    sinNumber: "",
    transitNumber: "",
    institutionNumber: "",
    accountType: "Checking",
    accountNumber: "",
  });

  const [earningData, setEarningData] = useState({})
  const [loading, setLoading] = useState(false);
    const [transactions, setTransactions] = useState([]);
    const [tableLoading, setTableLoading] = useState(false);

    const filtered = transactions.filter((t) => {
        return status.name === "Status" || t.status === status.name;
    });

  const handleFormChange = (e) => {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const getEarningsData = async ()=>{
      setLoading(true)
      try {
          const res = await apiRequests.get("/transaction/seller-transaction-dashboard")
          setEarningData(res.data.message)
      }
      catch (error) {
          console.log(error);
      }
      finally {
          setLoading(false)
      }
  }

    useEffect(() => {
        getEarningsData()
    }, []);

    const getTransactions = async (type) => {
        setTableLoading(true);

        try {
            const endpoint =
                type === "Orders"
                    ? "/transaction/seller-transaction-orders"
                    : "/transaction/seller-transaction-payouts";

            const res = await apiRequests.get(endpoint);

            setTransactions(res.data.message.docs || []);
        } catch (error) {
            console.log(error);
        } finally {
            setTableLoading(false);
        }
    };

    useEffect(() => {
        getTransactions(activeFilter);
    }, [activeFilter]);


  return (
    <div className="min-h-screen flex items-start justify-center py-8 px-10 font-inter">
      <div className="bg-white rounded-2xl shadow-sm w-full">
        <h1 className="text-2xl font-bold text-[#051F33] mb-6">
          Earnings & Payouts
        </h1>

        {/* Cards */}
        <div className="grid grid-cols-12 gap-4 mb-8 items-stretch min-h-32">
          <div className="col-span-4 bg-[#BBDCBC] text-[#204422] rounded-2xl p-5 flex flex-col justify-between shadow-lg">
            <span className="text-lg font-medium">Total Earnings</span>
            <span className="text-3xl font-bold mt-3">$ {earningData?.totalEarning}</span>
          </div>
          <div className="col-span-3 bg-[#ADD3F2] text-[#051F33] rounded-2xl p-5 flex flex-col justify-between shadow-lg">
            <span className="text-lg font-medium">Available balance</span>
            <span className="text-3xl font-bold mt-3">$ {earningData?.availabaleBalance}</span>
          </div>
          <div className="col-span-3 bg-[#FFE9A6] rounded-2xl p-5 flex flex-col justify-between relative shadow-lg">
            <div className="flex items-center gap-1">
              <span className="text-lg font-medium text-[#634C05]">
                Pending balance
              </span>
              <div className="relative">
                <MdErrorOutline
                  onMouseEnter={() => setShowTooltip(true)}
                  onMouseLeave={() => setShowTooltip(false)}
                  className="w-5 h-5 text-[#634C05]"
                />
                {showTooltip && (
                  <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 bg-neutral-300 text-neutral-800 text-xs rounded-lg px-3 py-1.5 whitespace-nowrap shadow-lg z-10">
                    Funds will be available after order completion
                    <div className="absolute top-full left-1/2 -translate-x-1/2 border-4 border-transparent border-t-neutral-300" />
                  </div>
                )}
              </div>
            </div>
            <span className="text-3xl font-bold text-[#634C05] mt-3">
              $ {earningData?.pendingBalance}
            </span>
          </div>

          <button
            onClick={() => setShowModal(true)}
            className="col-span-2 bg-[#051F33] hover:bg-[#024E88] transition-colors rounded-2xl p-5 text-white text-base flex items-center justify-center text-center shadow-lg"
          >
            Request payout
          </button>
        </div>

        {/* Filters */}
        <div className="flex items-center justify-between mb-4 flex-wrap gap-3">
          <div className="flex items-center gap-3">
            <h2 className="text-xl font-semibold text-[#051F33]">
              Transaction History
            </h2>
            <div className="flex items-center gap-1 rounded-full p-1">
              {FILTERS.map((f) => (
                <button
                  key={f}
                  onClick={() => setActiveFilter(f)}
                  className={`border rounded-xl px-6 py-2 font-medium transition-colors ${
                    activeFilter === f
                      ? "bg-[#BCB6B3] text-black border-[#BCB6B3]"
                      : "border-[#5C5957] text-[#5C5957] hover:bg-[#BCB6B3]"
                  }`}
                >
                  {f}
                </button>
              ))}
            </div>
          </div>
          {/* Status */}
          <div className="relative flex items-center ml-auto">
            <button
              onClick={() => setOpen((prev) => !prev)}
              className="w-40 z-20 bg-white border border-neutral-600 text-neutral-600 rounded-xl px-4 py-2 flex justify-between items-center"
            >
              {status.name || "Status"}
              <MdKeyboardArrowDown className="ml-2 h-5 w-5" />
            </button>
            {open && (
              <ul className="absolute top-full mt-2 w-full bg-white border border-gray-300 rounded-2xl shadow-lg z-30">
                <li
                  onClick={() => {
                    setStatus({ id: "", name: "Status" });
                    setOpen(false);
                  }}
                  className="py-2 cursor-pointer text-neutral-700 hover:bg-gray-100 border-b border-gray-200 mx-4"
                >
                  All
                </li>
                {statusList.map((option, i) => (
                  <li
                    key={i}
                    onClick={() => {
                      setStatus(option);
                      setOpen(false);
                    }}
                    className="py-2 cursor-pointer text-neutral-700 hover:bg-gray-100 border-b border-gray-200 last:border-b-0 mx-4"
                  >
                    {option.name}
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>

        {/* Table */}
        <table className="w-full text-left table-fixed">
          <thead>
            <tr className="bg-gradient-to-r from-[#051F33] to-[#024E88] text-white">
              <th className="w-[20%] p-4 pl-10 font-medium capitalize rounded-tl-2xl">
                Amount
              </th>
              <th className="w-[20%] p-4 font-medium capitalize">Type</th>
              <th className="w-[20%] p-4 font-medium capitalize">ID</th>
              <th className="w-[18%] p-4 font-medium capitalize text-center">
                Status
              </th>
              <th className="w-[22%] p-4 font-medium capitalize text-start rounded-tr-2xl">
                Time / Date
              </th>
            </tr>
          </thead>
          <tbody>
            {filtered.length === 0 ? (
              <tr>
                <td
                  colSpan={5}
                  className="text-center py-10 text-gray-400 text-sm"
                >
                  No transactions found.
                </td>
              </tr>
            ) : (
              filtered.map((tx) => (
                <tr
                  key={tx.id}
                  className="border-b border-[#AE9C91] hover:bg-gray-100 transition-colors h-14"
                >
                  <td className="p-4 pl-4">
                    <div className="flex items-center gap-2">
                      <span className="w-8 h-8 rounded-full flex items-center justify-center text-lg">
                        {tx.sign}
                      </span>
                      <span className="text-gray-800 text-lg">
                        $ {tx.amount}
                      </span>
                    </div>
                  </td>
                  <td className="p-4 text-neutral-950 text-lg">{tx.type}</td>
                  <td className="p-4 text-neutral-950 text-lg">{tx.txId}</td>
                  <td className="p-4 text-center">
                    <span
                      className={`text-lg ${tx.status === "Successful" ? "text-[#4CAF50]" : "text-[#F44336]"}`}
                    >
                      {tx.status}
                    </span>
                  </td>
                  <td className="p-4">
                    <div className="flex items-center justify-between">
                      <span className="text-lg text-neutral-950">
                        {tx.date}
                      </span>
                      {tx.hasLink && (
                        <a
                          href="#"
                          className="text-blue-500 hover:text-blue-700 transition-colors"
                          title="View order"
                        >
                          <MdOutlineArrowOutward />
                        </a>
                      )}
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* Modal */}
      {showModal && (
        <div
          className="fixed inset-0 bg-black/50 flex items-center justify-center z-50"
          onClick={() => setShowModal(false)}
        >
          <div
            className="bg-white rounded-2xl shadow-xl w-full max-w-lg mx-4 p-6"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex items-center justify-between mb-3">
              <h2 className="text-xl font-bold text-[#051F33]">
                Request payout
              </h2>
              <IoCloseCircleOutline
                onClick={() => setShowModal(false)}
                className="w-7 h-7"
              />
            </div>

            <p className="text-sm text-gray-600 mb-5">
              We process payouts securely. Once approved, funds are transferred
              to your bank within 1–3 business days.
            </p>

            <div className="grid grid-cols-2 gap-4">
              <div className="flex flex-col gap-1">
                <label className="text-sm text-neutral-950">
                  Account holder name
                </label>
                <input
                  name="accountHolder"
                  value={form.accountHolder}
                  onChange={handleFormChange}
                  placeholder="Enter full legal name"
                  className="border border-neutral-400 rounded-lg px-3 py-2 text-sm outline-none focus:border-[#024E88] placeholder-neutral-400"
                />
              </div>
              <div className="flex flex-col gap-1">
                <label className="text-sm text-neutral-950">SIN number</label>
                <input
                  name="sinNumber"
                  value={form.sinNumber}
                  onChange={handleFormChange}
                  placeholder="000 000 000"
                  className="border border-neutral-400 rounded-lg px-3 py-2 text-sm outline-none focus:border-[#024E88] placeholder-neutral-400"
                />
              </div>
              <div className="flex flex-col gap-1">
                <label className="text-sm text-neutral-950">
                  Transit number
                </label>
                <input
                  name="transitNumber"
                  value={form.transitNumber}
                  onChange={handleFormChange}
                  placeholder="5-digit branch number"
                  className="border border-neutral-400 rounded-lg px-3 py-2 text-sm outline-none focus:border-[#024E88] placeholder-neutral-400"
                />
              </div>
              <div className="flex flex-col gap-1">
                <label className="text-sm text-neutral-950">
                  Institution number
                </label>
                <input
                  name="institutionNumber"
                  value={form.institutionNumber}
                  onChange={handleFormChange}
                  placeholder="3-digit bank number"
                  className="border border-neutral-400 rounded-lg px-3 py-2 text-sm outline-none focus:border-[#024E88] placeholder-neutral-400"
                />
              </div>
              {/* dropdown */}
              <div className="flex flex-col gap-1">
                <label className="text-sm text-neutral-950">Account type</label>

                <div className="relative">
                  <button
                    type="button"
                    onClick={() => setOpenAccountType((prev) => !prev)}
                    className="
        w-full
        border border-neutral-400
        rounded-lg
        px-3 py-2
        text-sm
        outline-none
        bg-white
        flex items-center justify-between
        focus:border-[#024E88]
      "
                  >
                    <span className="text-neutral-700">
                      {form.accountType || "Select account type"}
                    </span>
                    <MdKeyboardArrowDown className="text-gray-500" />
                  </button>

                  {openAccountType && (
                    <ul className="absolute top-full mt-2 w-full bg-white border border-gray-300 rounded-lg shadow-lg z-30">
                      {accountTypes.map((t, i) => (
                        <li
                          key={i}
                          onClick={() => {
                            setForm((prev) => ({
                              ...prev,
                              accountType: t,
                            }));
                            setOpenAccountType(false);
                          }}
                          className="py-2 text-sm cursor-pointer text-neutral-700 hover:bg-gray-100 border-b border-gray-200 last:border-b-0 mx-3"
                        >
                          {t}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
              <div className="flex flex-col gap-1">
                <label className="text-sm text-neutral-950">
                  Account Number
                </label>
                <input
                  name="accountNumber"
                  value={form.accountNumber}
                  onChange={handleFormChange}
                  placeholder="7–12 digit account number"
                  className="border border-neutral-400 rounded-lg px-3 py-2 text-sm outline-none focus:border-[#024E88] placeholder-neutral-400"
                />
              </div>
            </div>

            <p className="text-xs text-gray-500 mt-4 mb-5">
              Your bank details are encrypted and stored securely.
            </p>

            <div className="flex items-center gap-3">
              <button className="bg-[#051F33] hover:bg-[#024E88] text-white rounded-xl px-10 py-2.5 text-sm font-medium transition-colors">
                Send request
              </button>
              <button className="border border-[#051F33] text-[#051F33] rounded-xl px-6 py-2.5 text-sm font-medium hover:bg-gray-50 transition-colors">
                Save bank details
              </button>
              <button
                onClick={() => setShowModal(false)}
                className="border border-red-400 text-red-500 rounded-xl px-6 py-2.5 text-sm font-medium hover:bg-red-50 transition-colors"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
